import React, { useCallback, useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import { api } from "../lib/api";
import IframeBanner from "../components/mfa/IframeBanner";
import StepUpPanel from "../components/mfa/StepUpPanel";
import { PasskeysSection, TotpSection, RecoverySection, TrustedDevicesSection } from "../components/mfa/SecuritySections";
import FounderRecovery from "../components/mfa/FounderRecovery";
import { useAuth } from "../lib/auth";

export default function SecuritySettings() {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);
  const [devices, setDevices] = useState([]);
  const [stepUp, setStepUp] = useState(null);
  const [err, setErr] = useState("");
  const reload = useCallback(() => {
    api.get("/mfa/status").then((r) => setStatus(r.data)).catch(() => setErr("Couldn't load your sign-in security."));
    api.get("/mfa/trusted-devices").then((r) => setDevices(r.data)).catch(() => setDevices([]));
  }, []);
  useEffect(() => { reload(); }, [reload]);

  const hasFactor = !!status && (status.passkeys.length > 0 || status.totp.status === "active");
  const token = stepUp && stepUp.until > Date.now() ? stepUp.token : null;
  const props = { status, token, firstFactor: !hasFactor, hasFactor, reload };
  return (
    <AppShell title="Sign-in security" subtitle="Passkeys, authenticator app, recovery codes">
      <div className="mx-auto w-full max-w-[860px] px-4 md:px-6 space-y-4" data-testid="security-settings">
        <IframeBanner />
        {err && <p role="alert" className="text-sm text-red-700" data-testid="security-error">{err}</p>}
        {!status && !err && <p className="font-mono text-xs" data-testid="security-loading">Loading…</p>}
        {status && (
          <>
            {hasFactor && <StepUpPanel status={status} stepUp={stepUp} setStepUp={setStepUp} />}
            <PasskeysSection {...props} />
            <TotpSection {...props} />
            <RecoverySection {...props} />
            <TrustedDevicesSection devices={devices} reload={reload} />
            {user?.role_key === "OWNER_SUPER_ADMIN" && <FounderRecovery />}
          </>
        )}
      </div>
    </AppShell>
  );
}
